const SDK_VERSION = '7.34.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
